import { useAuth, useUser } from "@clerk/clerk-react";
import { Sheet, SheetContent, SheetTrigger } from "Components/ui/sheet";
import { LogOut, Menu } from "lucide-react";
import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import key from "../../../Assets/Images/key.svg";
import CredentialsPopup from "Pages/ChallengeOverview/Components/CredentialsPopup";

function MenuSheet({ data, page }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const { signOut } = useAuth();

  const handleSignout = () => {
    signOut();
  };

  const { pathname } = useLocation();

  const [openCredentials, setOpenCredentials] = useState(false);

  const handleCredentialsPopup = () => {
    setOpenCredentials(true);
    setOpen(false);
  };

  return (
    <>
      <Sheet open={open} onOpenChange={(e) => setOpen(e)}>
        <SheetTrigger>
          <Menu className="opacity-[0.3] cursor-pointer" />
        </SheetTrigger>
        <SheetContent side="left" className="border-none">
          {data.map((item, index) => (
            <div
              key={index}
              className="p-2 cursor-pointer"
              onClick={() => {
                setOpen(false);
                page == "challenges"
                  ? navigate(`/challenge/${pathname?.split("/")[2]}/` + item)
                  : page == "main"
                  ? navigate("/" + item)
                  : navigate("/profile?tab=" + index);
              }}
            >
              {item}
            </div>
          ))}
          {page == "challenges" ? (
            <div
              className="text-lightBlue flex flex-row items-center gap-2 p-2 cursor-pointer"
              onClick={handleCredentialsPopup}
            >
              <img src={key} alt="key" className="w-[1.2rem]" />
              Credentials
            </div>
          ) : (
            <div
              className="text-red flex flex-row items-center gap-2 p-2 cursor-pointer"
              onClick={handleSignout}
            >
              <LogOut size={"1.2rem"} />
              Logout
            </div>
          )}
        </SheetContent>
      </Sheet>
      <CredentialsPopup open={openCredentials} setOpen={setOpenCredentials} />
    </>
  );
}

export default MenuSheet;
